/**
 * The guide promoted at the top of the homepage guide list and the /guides
 * hub. Swap it as the seasons change (Thanksgiving in November, Christmas in
 * December) so the page Google should crawl first gets the strongest links.
 */
export const featuredGuide = {
  slug: "scary-movies-to-watch-with-friends",
  label: "Halloween pick",
  text: "Scary movies to watch with friends this Halloween",
};
